
import moment from 'moment';
import { Component, Mixins } from 'vue-property-decorator';
import { WarehouseType } from '@/types';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationMaterialsTargetDate extends Mixins(OperationComponentMixin) {
  get warehouse(): WarehouseType | null {
    if (this.childProjectType === 'elettrica-figlia') {
      return this.operation
        && this.operation.eWarehouse
        ? this.operation.eWarehouse
        : null;
    }

    if (this.childProjectType === 'termica-figlia') {
      return this.operation
        && this.operation.tWarehouse
        ? this.operation.tWarehouse
        : null;
    }
    return null;
  }

  get warehouseIcon(): string {
    switch (this.warehouse) {
      case 'yes':
        return 'mdi-archive-check';

      case 'partial':
        return 'mdi-archive-refresh';

      case 'no':
        return 'mdi-archive-off';

      default:
        break;
    }

    return 'mdi-archive-off-outline';
  }

  get warehouseIconColor(): string {
    return this.warehouse ? 'statusDone' : 'grey lighten-2';
  }

  get warehouseText(): string {
    switch (this.warehouse) {
      case 'yes':
        return 'Disponibilità materiale: in magazzino';

      case 'partial':
        return 'Disponibilità materiale: parziale in magazzino';

      case 'no':
        return 'Disponibilità materiale: non in magazzino';

      default:
        break;
    }

    return 'Disponibilità materiale: non definita';
  }

  get warehouseTooltipColor(): string {
    return this.warehouse ? 'success' : '';
  }

  get materialsTargetDateViewMode(): string {
    let materialsTargetDateViewMode = 'week';

    if (this.childProjectType === 'elettrica-figlia') materialsTargetDateViewMode = this.operation?.eMaterialsTargetDateViewMode;
    if (this.childProjectType === 'termica-figlia') materialsTargetDateViewMode = this.operation?.tMaterialsTargetDateViewMode;

    return materialsTargetDateViewMode;
  }

  get materialsTargetDate(): string | null {
    let materialsTargetDate: Date | null = null;

    if (this.childProjectType === 'elettrica-figlia') materialsTargetDate = this.operation.eMaterialsTargetDate;
    if (this.childProjectType === 'termica-figlia') materialsTargetDate = this.operation.tMaterialsTargetDate;

    // Restituisce la data nel formato richiesto
    switch (this.materialsTargetDateViewMode) {
      case 'single':
        return materialsTargetDate && moment(materialsTargetDate).isValid()
          ? this.mDate(materialsTargetDate)
          : null;

      case 'week':
        return materialsTargetDate && moment(materialsTargetDate).isValid()
          ? `WW ${moment(materialsTargetDate).format('WW-GGGG')}`
          : null;

      default:
        return null;
    }
  }

  get notes(): string | null {
    return this.operationChild?.shipmentNotes || null;
  }

  get partialShipment(): boolean {
    return this.operationChild?.partialShipment === true;
  }

  get shipmentReady(): boolean {
    return this.operationChild?.shipmentReady === true;
  }

  get tooltipColor(): string {
    if (this.operationChild?.flatTasks.includes('M=c')) return 'success';
    if (this.operationChild?.flatTasks.includes('M=e')) return 'error';
    return 'success';
  }

  get tooltipText() {
    if (this.notes
      && this.isCurrentUserOwnerOrRequester
      && this.hasPermission('taskm.notes.show')
    ) return this.notes;

    return 'Data obiettivo del materiale in cantiere';
  }

  get columnClass(): string {
    // Se l'intero Task M è completo o in errore, collora la colonna
    if (this.operationChild?.flatTasks.includes('M=c')) return 'completed';
    if (this.operationChild?.flatTasks.includes('M=e')) return 'error';

    if (this.partialShipment || this.shipmentReady) return 'selected';

    return '';
  }

  onEdit() {
    console.log('OperationMaterialsTargetDate: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
